export function Input({ className = '', ...props }) {
    return (
        <input
            className={`rounded px-3 py-2 focus:outline-none border-checkout-border focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${className}`}
            {...props}
        />
    );
}